module.exports = "<div class=\"home\">\n  <h1>Semesters</h1>\n  <md-list>\n    <md-list-item v-for=\"(semester, i) in semesters\" :key=\"i\" :href=\"'#/semester/' + semester.id\">\n      <span>{{semester.id}}. Semester</span>\n\n      <md-button class=\"md-icon-button md-list-action\">\n        <md-icon class=\"md-primary\" @click.prevent.native=\"remove(semester)\">clear</md-icon>\n      </md-button>\n    </md-list-item>\n  </md-list>\n\n  <md-button class=\"md-raised md-primary md-icon-button\" @click.native=\"add\">\n    <md-icon>add</md-icon>\n  </md-button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home.html
// module id = 104
// module chunks = 1